<template minapp="mpx" xlang="wxml">
  <view wx:ref="container" class="train-order-information-ticket" wx:class="{{{'hide-refund': !!order.hideNum && hideRefund}}}"> 
    <block wx:for="{{orderList}}" >
      <view class="item" wx:class="{{{'less-bottom': item.showStatus && !(item.isRefunding || item.isChanging)}}}">
        <view class="left" 
          wx:class="{{{'gray': !order.isAllGray && item.isGray}}}" 
          wx:style="{{{'margin-bottom': item.showStatus && !item.status_name ? '5px' : '0'}}}"
        >
          <view class="top">
            <view class="name">
              {{ item.passenger_name }}
            </view>
            <view class="state-card">
              <view class="card" wx:if="{{item.ticket_type}}">{{ getType(item) }}</view>
            </view>
            <view class="price-seat"  wx:if="{{!item.showStatus}}">
              <view class="seat-type">{{ item.seat_type }}</view>
              <view class="seat-price">{{ price(item) }}</view>
            </view>
          </view>
          <view class="bottom" wx:if="{{item.showStatus}}">
            <view class="seat-type">{{ item.seat_type }}</view>
            <view class="seat-price">{{ price(item) }}</view>
          </view>
        </view>
        <view class="right">
          <view wx:if="{{(showSeatStatus.includes(item.status) || item.showStatus || tickets12306) && getSeatText(item)}}" 
            class="top"
            wx:class="{{{'gray': !order.isAllGray && item.isGray}}}"
          >
            <view class="card" wx:if="{{ item.is_beside_window }}">靠窗</view>
            <view class="card" wx:if="{{ item.special_flag }}">静</view>
            <view>{{ getSeatText(item) }}</view>
          </view>
          <view wx:elif="{{item.status_name}}" class="top" wx:class="{{{'gray': !order.isAllGray && item.isGray}}}">{{
            item.status_name
          }}</view>
          <view class="status-wrapper" wx:if="{{item.showStatus}}" wx:class="{{{'more-top': item.isRefunding || item.isChanging, 'no-top': !item.status_name}}}">
            <view class="status-btn" wx:if="{{item.isRefunded}}" bindtap="toRefundPage(item)">
              退票详情
            </view>
            <view class="status-btn" wx:if="{{item.newChange}}" bindtap="toChangePage(item)">
              改签详情
            </view>
            <view class="status-btn" wx:if="{{item.canRefund && !item.waitingPay}}"  bindtap="invokeDrawer(item, 'refund')">
              退票
            </view>
            <view class="status-btn" wx:if="{{item.canChange && !item.waitingPay}}" bindtap="invokeDrawer(item, 'change')">
              改签
            </view>
            <view class="status-btn paid" wx:if="{{item.waitingPay}}" >
              待支付
            </view>
            <view class="status-btn text" wx:if="{{item.isRefunding || item.isChanging}}" >
              {{item.status_name ?? ''}}
            </view>
          </view>
          </view>
        </view>
      </view>
      <view wx:if="{{order.hideNum && hideRefund}}" class="remainder" bindtap="showAllTicket">查看剩余{{order.hideNum}}名乘客</view>
    </block>
  </view>
</template>

<script>
    import { createComponent } from '@didi/es-mpx-creator'
    import { getFinalPrice } from '@/utils/money'
    import { innerRouter, pagePath } from '@/common/jump'
    import { OrderStatus, TicketStatus } from '@/common/enum'
    import { compareNow, showBtns, showChangeBtn } from '@/common/order'
    import store from '@/store'

    createComponent({
      props: {
        order: {
          type: Object
        },
        hasSeat: {
          type: Boolean
        },
        hasBeenGray: {
          type: Boolean,
          value: false
        },
        tickets12306: {
          type: Boolean,
          value: false
        }
      },
      data() {
        return {
          showSeatStatus: [2, 3, 4],
          hideRefund: true // 默认隐藏已退的票
        }
      },
      computed: {
        ...store.mapState({
          baseInfo: 'order.base_info'
        }),
        heightStyle() {
          return {
            height: this.containerHeight
          }
        },
        orderList() {
          return this.hideRefund ? this.order.tickets_info : this.order.all_tickets_info
        }
      },
      methods: {
        ...store.mapMutations({
          setTikcetOperateDrawerStatus: 'order.setTikcetOperateDrawerStatus'
        }),
        price(item) {
          const _price = getFinalPrice(+item.ticket_price || item.personal_pay)
          return this.tickets12306 ? `¥${item.price}` : `¥${_price}`
        },
        getType(item) {
          const type = +item?.ticket_type || ''
          return type == 3 ? '学生票' : type === 2 ? '儿童票' : '成人票'
        },
        toRefundPage(item) {
          innerRouter.push(pagePath().REFUNDTICKETDETAILPAGE, {
            order_id: this.baseInfo?.original_order_id || this.baseInfo?.order_id,
            selected_ticket_id: item?.ticket_id,
            from: this.from
          })
        },
        toChangePage(item) {
          innerRouter.push(pagePath().CHANGETICKETDETAILPAGE, {
            order_id: this.baseInfo?.original_order_id || this.baseInfo?.order_id,
            selected_ticket_id: item?.ticket_id,
            from: this.from
          })
        },
        showAllTicket() {
          this.hideRefund = false
          this.refresh()
        },
        getSeatText(item) {
          return item.coach_no ? `${item.coach_no}车${item.seat_name}` : `${item.status_name}`
        },
        invokeDrawer(ticket, type) {
          const info = {
            show: true,
            type,
            ticketId: ticket.ticket_id ?? '',
            segmentId: ticket.union_segment_index ? ticket.union_segment_index - 1 : 0
          }
          this.setTikcetOperateDrawerStatus(info)
        },
        refresh() {
          this.triggerEvent('refresh')
        }
      }
    })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .train-order-information-ticket
    background #D2E6FF
    border-radius 0 0 10px 10px
    transition height 0.3s linear
    overflow hidden
    &.hide-refund
      border-radius 0
    .item
      display flex
      box-sizing border-box
      position relative
      padding 14px 16px
      justify-content space-between
      &.less-bottom
        padding-bottom 9px
      .left
        display flex
        flex-direction column
        .top
          display flex
          align-items center
          .name
            font-family PingFangSC-Medium
            font-size 15px
            line-height 15px
            color #222
          .state-card
            display flex
            align-items center
          .price-seat
            display flex
            .seat-type
              color #666
              margin-left 4px
              line-height 13px
              font-size 13px
            .seat-price
              line-height 13px
              font-size 13px
              color #666
              margin-left 2px
        .bottom
          margin-top 12px
          display flex
          font-family PingFangSC-Regular
          font-size 13px
          line-height 13px
          color #222
          .seat-price
            margin-left 4px
      .right
        display flex
        flex-direction column
        justify-content space-between
        .top
          font-family PingFangSC-Medium
          font-size 15px
          line-height 15px
          color #222
          display flex
          flex-direction row-reverse
        .bottom
          margin-top 12px
        .status-wrapper
          display flex
          flex-direction row-reverse
          margin-top 8px
          &.more-top
            margin-top 10px
          &.no-top
            margin-top 0
          .status-btn
            padding 5px 12px
            box-sizing border-box
            display flex
            flex-direction row-reverse
            line-height 12px
            font-size 12px
            font-family PingFangSC-Regular
            font-weight 400
            background #fff
            color #338FFF
            border-radius 50px
            &:not(:last-child)
              margin-left 5px
            &.paid
              color #FF6400
            &.text
              font-size 15px
              font-family PingFangSC-Medium
              font-weight 500
              line-height 15px
              padding 0
              background transparent
      &:not(:last-child)
        &::after
          position absolute
          content ''
          width 646px
          height 1px
          background #B0D3FF
          box-sizing border-box
          transform-origin 0 0
          transform scale(0.5) translate(-50%)
          border-radius 12px
          bottom 0
          left 50%
  .card
    position relative
    box-sizing border-box
    padding 2px
    margin-left 4px
    border-radius 3px
    font-family PingFangSC-Regular
    font-size 10px
    line-height 10px
    color #5F88C8
    &::after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #5F88C8
      transform-origin 0 0
      transform scale(0.5)
      border-radius 6px
      top 0
      left 0
  .gray
    opacity 0.6
  .label
    margin-right 9px
    font-size 13px
    line-height 13px
  .remainder
    position relative
    background #D2E6FF
    padding 10px 0
    text-align center
    line-height 12px
    border-radius 0 0 10px 10px
    font-size 12px
    color #5F88C8
    &::before
      position absolute
      content ''
      width 646px
      height 1px
      background #B0D3FF
      box-sizing border-box
      transform-origin 0 0
      transform scale(0.5) translate(-50%)
      border-radius 12px
      top 0
      left 50%
</style>

<script name="json">
    module.exports = {
      component: true
    }
</script>